// Company identity and contact details. Demo placeholders: replace with real SDL information.
export const company = {
  name: 'Sheba Digital Limited',
  short: 'SDL',
  parent: 'Sheba Group',
  tagline: 'Building Digital Solutions That Move Businesses Forward',
  lead:
    'Sheba Digital Limited delivers scalable software, digital platforms, and technology solutions that help organizations operate smarter, faster, and more efficiently.',
  description:
    'Sheba Digital Limited is a technology company under Sheba Group, building software, digital platforms and enterprise solutions for long-term partners.',
};

export const heroSlides = [
  { title: company.tagline, text: company.lead },
  { title: 'Technology Partnership That Lasts Beyond Launch', text: 'From custom software to cloud platforms, we stay with our clients to support, monitor and improve every system we deliver.' },
];

export const contact = {
  company: 'Sheba Digital Limited',
  address: 'House#52, Road# 3/A, Dhanmondi-1209, Dhaka',
  headOffice: 'House#55, Road#4/A, Dhanmondi-1209, Dhaka',
  phone: '09610912912',
  email: 'info@shebadigital.com',
  hours: 'Sunday - Thursday, 9:00 AM - 6:30 PM',
  // Map embed (no API key needed) and the shareable link for "Open in Google Maps".
  mapEmbedUrl: 'https://maps.google.com/maps?q=23.7401416,90.3759119&z=17&output=embed',
  mapLink: 'https://maps.app.goo.gl/FKYXDUWxxhxk7dUF8',
};

// Leave url empty to render the icon as a non-link placeholder.
export const socials = [
  { name: 'Facebook', icon: 'facebook', url: '' },
  { name: 'LinkedIn', icon: 'linkedin', url: '' },
  { name: 'YouTube', icon: 'youtube', url: '' },
  { name: 'X', icon: 'x', url: '' },
];

export const navItems = [
  { label: 'Home', id: 'home', route: '/' },
  { label: 'About Us', id: 'about', route: '/about' },
  { label: 'Services', id: 'services', route: '/services' },
  { label: 'Products', id: 'products', route: '/products' },
  { label: 'Portfolio', id: 'portfolio', route: '/portfolio' },
  { label: 'Career', id: 'career', route: '/career' },
  { label: 'Contact', id: 'contact', route: '/contact' },
];

export const careers = {
  intro:
    'We are always happy to meet engineers, designers and analysts who care about building dependable software. Open positions will be listed here.',
  openings: [
    { title: 'Software Engineer (Demo)', type: 'Full-time', location: 'On-site' },
    { title: 'UI/UX Designer (Demo)', type: 'Full-time', location: 'On-site' },
    { title: 'QA Engineer (Demo)', type: 'Full-time', location: 'On-site' },
  ],
  email: 'info@shebadigital.com',
};
